module.exports = __webpack_public_path__ + "static/prtyr-138ff89a6e7b24562b7e9d2c45cb8bae.png";